import React, { useContext, useEffect } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import AppConfig from "../../config";

const SignIn = () => {
  const { loggedIn, handleSSOSignIn } = useContext(AuthContext); // Get signIn function from AuthContext
  const navigate = useNavigate();

  useEffect(() => {
    if (loggedIn) {
      navigate("/");
    } else {
      handleSSOSignIn();
    }
  }, [loggedIn, handleSSOSignIn]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh", // Ensures the content takes full screen height
        backgroundColor: "#fff", // Optional: Sets a background color
      }}
    >
      <CircularProgress sx={{ color: AppConfig.colorPalette.primary.main }} />{" "}
      {/* Optional: Spinner for visual feedback */}
      <Typography
        variant="h6"
        sx={{ color: AppConfig.colorPalette.primary.main }}
      >
        Please wait while we authorize you...
      </Typography>
    </Box>
  );
};

export default SignIn;
